import Link from 'next/link';

/**
 * GF provider card (.pc): logo + name + description + footer action row (.ft).
 * Shared by the VPN/Insurance/Transport/Tours service grids (non-clickable
 * <article> with an affiliate button in the footer) and by the Stay provider
 * grid (clickable <Link> card) — the card body is identical, so it's the same
 * component. The footer action differs, so it's passed as children.
 *
 * @param {string}          name        provider name (also watermark / logo alt fallback)
 * @param {string}          logo        logo image URL (falls back to a watermark)
 * @param {string}          logoAlt     logo alt text (defaults to `name`)
 * @param {string}          description short blurb (.vd)
 * @param {string}          [href]      when set, the whole card is a <Link> to this URL
 * @param {string}          [stamp]     optional corner badge (.stamp), e.g. transport mode
 * @param {string}          [className] extra classes appended to `.pc`
 * @param {React.ReactNode} children    footer action(s), rendered after the price slot
 */
export default function GfProviderCard({ name, logo, logoAlt, description, href, stamp, className = '', children }) {
    const cls = `pc ${className}`.trim();
    const inner = (
        <>
            {stamp && <span className="stamp">{stamp}</span>}
            <div className="logo">{logo ? <img src={logo} alt={logoAlt || name} /> : <span className="wm">{name}</span>}</div>
            <div className="pc-body">
                <h3>{name}</h3>
                {description && <p className="vd">{description}</p>}
            </div>
            <div className="ft">
                <span className="pr" />
                {children}
            </div>
        </>
    );

    if (href) {
        return <Link className={cls} href={href}>{inner}</Link>;
    }
    return <article className={cls}>{inner}</article>;
}
